import moment from "moment";
import { TTimeFilterType, TIME_FILTER_OPTIONS } from "../constants";

const DAY_IN_MS = 1000 * 60 * 60 * 24;
const WEEK_IN_MS = DAY_IN_MS * 7;

export default function getXTicksByType({
  monthIndex,
  year,
  type,
}: {
  monthIndex: number;
  year: number;
  type: TTimeFilterType;
}) {
  // by week, return day
  if (type === TIME_FILTER_OPTIONS.last_week.id) {
    const now = new Date();
    const dd = String(now.getDate()).padStart(2, "0");
    const mm = String(now.getMonth() + 1).padStart(2, "0"); //January is 0!
    const yyyy = now.getFullYear();
    const todayDate = `${yyyy}-${mm}-${dd}`;
    const last = new Date(todayDate).getTime();

    return Array(7)
      .fill(last)
      .map((el, i) => el - i * DAY_IN_MS);
  }

  // by month, return week
  if (type === TIME_FILTER_OPTIONS.month.id) {
    const firstMonthTime = Date.UTC(year, monthIndex, 1, 0, 0, 0, 0);

    let firstWeekFirstTime = moment
      .utc(firstMonthTime)
      .startOf("week")
      .valueOf();
    const lastWeekFirstTime = moment
      .utc(firstMonthTime)
      .endOf("month")
      .startOf("week")
      .valueOf();

    const res: number[] = [];

    while (firstWeekFirstTime <= lastWeekFirstTime) {
      res.push(firstWeekFirstTime);
      firstWeekFirstTime += WEEK_IN_MS;
    }
    return res;
  }

  // by year, return month
  return Array(12)
    .fill(0)
    .map((_, i) => Date.UTC(year, i, 1, 0, 0, 0, 0));
}
